/**
 * How many seats a registration can still ask for, shared by the nominative trainee list and the
 * declarative learner-count input so their two bounds can never disagree.
 *
 * Per-session seats come from `data-available-seats` on the session select's options; a session with
 * no enforced capacity carries no attribute.
 */

// The one definition of "the session select", so every bound is read from the same element.
export const sessionSelect = (root) => (root.closest("form") ?? document).querySelector(".js-registration-date select");

export function seatsForSession(root, sessionId) {
  const select = sessionSelect(root);

  for (const option of select?.querySelectorAll("option[data-available-seats]") ?? []) {
    if (option.value === String(sessionId)) {
      return parseInt(option.dataset.availableSeats);
    }
  }

  return null;
}

// An offered session select is what makes a request inter: the seats are the picked session's. Its
// absence - or the intra button disabling it - means a session of this company's own.
export function initialRegistrationType(root) {
  const select = sessionSelect(root);

  return select && !select.disabled ? "inter" : "intra";
}

export function availableSeats(root, { registrationType, selectedSessionId, programCapacity }) {
  if (registrationType === "inter" && selectedSessionId) {
    return seatsForSession(root, selectedSessionId) ?? programCapacity;
  }

  return programCapacity;
}
